import React from 'react';

import icon from 'assets/images/softwares/WellBHPPredictor1.png';

const Icon = ({ width }) => <img src={icon} alt="Bottome Hole Pressure" width={width || '25'} />;

export default Icon;
